/* eslint-disable max-len */
import React from 'react';

import {
  Typography,
} from '@material-ui/core';
import BacePolicy from '../components/base_policy';

const IndexPage = () => (
  <BacePolicy>
    <ul>
      <li><Typography paragraph variant="body2">アカウントID</Typography></li>
      <li><Typography paragraph variant="body2">ユーザー作成のデータ</Typography></li>
      <li><Typography paragraph variant="body2">ファイル/画像/動画など</Typography></li>
    </ul>
  </BacePolicy>
);

export default IndexPage;
